import './i18n'

import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { appInsights, reactPlugin } from '@/analytics.ts'

import App from './App'
import { pca } from './utils/MSAL'

appInsights.loadAppInsights()

// Fix for users that already have accessed the website and have light theme as default
const firstVisit = localStorage.getItem('user-first-visit') ?? 'true'

if (firstVisit === 'true') {
    localStorage.setItem('user-first-visit', 'false')
    localStorage.removeItem('chakra-ui-color-mode')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <AppInsightsContext.Provider value={reactPlugin}>
            <App pca={pca} />
        </AppInsightsContext.Provider>
    </React.StrictMode>,
)
